import axios from 'axios'
import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../../Constant'

import MUIDataTable from 'mui-datatables'
import { Link } from 'react-router-dom'
import { Button } from '@material-ui/core' // Assuming you're using Material-UI
import CheckPermission from '../../../common/Permissions/CheckPermission'

class PagesMetaDataSettings extends Component {
  state = {
    isloading: false,
    list: [],
    editingOrderNumberId: null,
    editingOrderValue: null,
    isEditingOrderNumber: false,
  }

  componentDidMount() {
    this.getConstant()
  }

  getConstant = async () => {
    this.setState({ isloading: true })

    await axios
      .get(Constant.getAPI() + `/admin/get-all-meta-data-for-pages`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            list: res?.data?.data || [],
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isloading: false })
      })
  }

  deleteContent = async (id) => {
    await axios
      .delete(Constant.getAPI() + `/admin/delete-meta-data-for-page/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          Swal.fire({
            title: 'Deleted Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          this.getConstant()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isloading: false })
      })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'page_link',
        label: 'Link',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'meta_title_en',
        label: 'Meta Title (EN)',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-start">
                <Link
                  to={'/create-page-meta-data/edit/' + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <CheckPermission permission={'create-delete-meta-tag-for-pages'}>
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.deleteContent(id)
                    }}
                  >
                    <i className="f-20 icofont icofont-delete-alt text-danger"></i>
                  </div>
                </CheckPermission>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      filter: false,
      search: false,
      textLabels: {
        body: {
          noMatch: this.state.isloading ? 'Loading data..!' : 'Sorry, No Record Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div>
        <div className="page-header">
          <div className="row align-items-end">
            <div className="col-lg-8">
              <div className="page-header-title">
                <div className="d-inline">
                  <h4>Meta Tags - Website Pages</h4>
                </div>
              </div>
            </div>
            <CheckPermission permission={'create-delete-meta-tag-for-pages'}>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <Button
                    startIcon={<i className="icofont icofont-plus"></i>}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      window.location.href = '#/create-page-meta-data/add'
                    }}
                  >
                    Add New Page
                  </Button>
                </div>
              </div>
            </CheckPermission>
          </div>
        </div>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <MUIDataTable
                className="table-responsive"
                data={this.state.list}
                columns={columns}
                options={options}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default PagesMetaDataSettings
